import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'document-uploader',
    templateUrl: './document-uploader.component.html',
    styleUrls: ['./document-uploader.component.scss'],
    standalone: false
})
export class DocumentUploaderComponent {

    imageSrc: string = '';

    @Input() docUrl;
    @Input() maxFileSizeMb = 5;
    @Input() progress;
    @Output() fileUpdated = new EventEmitter();
    @Output() delete = new EventEmitter();

    fileName: string;
    fileType: string;
    fileSize: number;

    handleInputChange(e) {
        var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
        console.log('handleInputChange');
        var reader = new FileReader();

        this.fileName = file.name;
        this.fileType = file.type;
        if(!file.type)
          this.fileType = 'unknown';
        this.fileSize = file.size;

        if (this.fileSize>(this.maxFileSizeMb*1024*1024)) {
            alert('Document is too big. Maximum allowed is '+this.maxFileSizeMb+'Mb');
            return;
        }

        console.log('File name is:'+file.name);
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsDataURL(file);
    }

    _handleReaderLoaded(e) {
        var reader = e.target;
        console.log('_handleReaderLoaded:'+reader.result);
        this.fileUpdated.emit({fileName:this.fileName, content:reader.result});
    }

    deleteFile(){
        this.delete.emit();
    }

}
